import { render, staticRenderFns } from "./AreaCheck.vue?vue&type=template&id=45b707b7&scoped=true"
import script from "./AreaCheck.vue?vue&type=script&lang=js"
export * from "./AreaCheck.vue?vue&type=script&lang=js"
import style0 from "./AreaCheck.vue?vue&type=style&index=0&id=45b707b7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45b707b7",
  null
  
)

export default component.exports